import Datalist from './Datalist.component';
import DatalistTextMode from './displayMode/TextMode.component';

export { DatalistTextMode };
export default Datalist;
